export const CELL_TYPES = {
  TITLE: 'TITLE',
  FIXED: 'FIXED',
  INPUT: 'INPUT',
  DROPDOWN: 'DROPDOWN',
  TEXT_ALIGNED: 'TEXT_ALIGNED',
  MATH_JAX: 'MATH_JAX',
  IMAGE: 'IMAGE'
};

export const DATA_TYPE = {
  STRING: 'string',
  NUMBER: 'number',
};
